import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import * as linkAction from "../../../../redux/actions/link.action";
import List from "../../../list/list";
import RetireePortalToggle from "../../../RetireePortalToggle/RetireePortalToggle";

const linkFields = [
  //list will sort by the first element by default
  "name",
  "link",
  "publishedAt",
];

const LinkList = ({ member = null }) => {
  const dispatch = useDispatch();
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const initialParams = {
    fieldTofilter: "name",
    filter: "",
    fieldToSort: "id",
    sortDirection: "asc",
    page: 1,
    pageSize: 8,
    member,
  };

  const { links, meta, listLoading, error } = useSelector((state) => ({
    links: state.link.linkList,
    meta: state.link.linkMetadata,
    listLoading: state.link.listLoading,
    error: state.link.error,
  }));

  useEffect(() => {
    linkAction.fetchAll(dispatch, initialParams);
  }, [dispatch, member]);

  const handleToggleRetireePortal = async (linkId, currentStatus) => {
    try {
      // Clear any previous messages
      setErrorMessage("");
      setAlertMessage("");
      setShowAlert(false);

      // Find the link data to send complete information
      const linkToUpdate = links?.data?.find(link => link.id === linkId);
      if (!linkToUpdate) {
        throw new Error('Link not found');
      }

      const formData = new FormData();
      const { attributes } = linkToUpdate;

      const formBody = { ...attributes, show_in_retiree_portals: !attributes.show_in_retiree_portals }

      formData.append("quickAccessLink", JSON.stringify(formBody));
      await linkAction.update(dispatch, linkId, formData);

      // Show success message
      const message = !currentStatus
        ? "Quick Access Link successfully added to retiree portals"
        : "Quick Access Link successfully removed from retiree portals";
      setAlertMessage(message);
      setShowAlert(true);
      
      // Refresh the list to show updated data
      linkAction.fetchAll(dispatch, initialParams);
    } catch (error) {
      console.error('Error updating retiree portal status:', error);
      // Clear success message and show error
      setAlertMessage("");
      setShowAlert(false);
      setErrorMessage("Error updating retiree portal status. Please try again.");
    }
  };

  return (
    <List
      title="Quick Access Links"
      tooltipTextDelete="Delete Quick Access Link"
      redirect={member ? `/quick-access/member/${member}/form` : `/quick-access/form`}
      columnNames={["NAME", "LINK", "Medicare Portals"]}
			entities={links?.data?.map(({ id, attributes: { name, link, show_in_retiree_portals } }) => ({
        id,
				columns: [
					{ primary: name },
          { primary: link },
          {
            primary: (
              <RetireePortalToggle
                id={id}
                showInRetireePortals={show_in_retiree_portals}
                onClick={(linkId) => handleToggleRetireePortal(linkId, show_in_retiree_portals)}
              />
            )
          }
				],
        name,
      }))}
      fieldsToSort={linkFields}
      fetchAction={(params) => linkAction.fetchAll(dispatch, {...params})}
      isOverview={false}
      metadata={meta}
      showFilterTab={false}
      member={member}
      deleteAction={(id, params) => linkAction.remove(dispatch, id, params)}
      listLoading={listLoading}
      showAlert={showAlert}
      setShowAlert={setShowAlert}
      successAlertMessage={alertMessage}
      customListError={errorMessage}
    />
  );
};

export default LinkList;
